/* OpticalH Help Center Controller v2.0 · 2026-07-20 */
(function () {
  'use strict';

  var ITEM = '.oh-help-acc-item';
  var BUTTON = '.oh-help-acc-q';
  var PANEL = '.oh-help-acc-a';
  var sequence = 0;

  function panelFor(item) {
    return item ? item.querySelector(PANEL) : null;
  }

  function buttonFor(item) {
    return item ? item.querySelector(BUTTON) : null;
  }

  function setOpen(item, open, focusButton) {
    if (!item) return;
    var button = buttonFor(item);
    var panel = panelFor(item);
    if (!button || !panel) return;

    item.classList.toggle('is-open', open);
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) panel.removeAttribute('inert');
    else panel.setAttribute('inert', '');
    panel.style.setProperty('max-height', open ? (panel.scrollHeight + 'px') : '0px', 'important');
    if (focusButton) button.focus({ preventScroll: true });
  }

  function closePeers(item) {
    var scope = item.closest('.oh-help') || document;
    scope.querySelectorAll(ITEM + '.is-open').forEach(function (peer) {
      if (peer !== item) setOpen(peer, false, false);
    });
  }

  function enhanceItem(item) {
    if (!item || item.getAttribute('data-oh-help-ready') === '1') return;
    var button = buttonFor(item);
    var panel = panelFor(item);
    if (!button || !panel) return;

    sequence += 1;
    var base = 'oh-help-accordion-' + sequence;
    if (button.tagName === 'BUTTON') button.type = 'button';
    if (!button.id) button.id = base + '-trigger';
    if (!panel.id) panel.id = base + '-panel';
    button.setAttribute('aria-controls', panel.id);
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-labelledby', button.id);
    item.setAttribute('data-oh-help-ready', '1');
    setOpen(item, item.classList.contains('is-open'), false);
  }

  function enhance(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(ITEM).forEach(enhanceItem);

    scope.querySelectorAll('.oh-help-nav').forEach(function (nav) {
      if (!nav.hasAttribute('role')) nav.setAttribute('role', 'navigation');
      if (!nav.hasAttribute('aria-label')) nav.setAttribute('aria-label', 'Centro de ayuda');
      nav.querySelectorAll('a[href]').forEach(function (link) {
        var current = new URL(link.href, location.href).pathname.replace(/\/$/, '');
        var here = location.pathname.replace(/\/$/, '');
        if (current === here) link.setAttribute('aria-current', 'page');
      });
    });

    scope.querySelectorAll('a[target="_blank"]').forEach(function (link) {
      var rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
      rel.add('noopener');
      rel.add('noreferrer');
      link.setAttribute('rel', Array.from(rel).join(' '));
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest(BUTTON);
    if (!button) return;
    var item = button.closest(ITEM);
    if (!item) return;
    event.preventDefault();
    var willOpen = button.getAttribute('aria-expanded') !== 'true';
    if (willOpen) closePeers(item);
    setOpen(item, willOpen, false);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var item = event.target.closest(ITEM);
    if (item && item.classList.contains('is-open')) setOpen(item, false, true);
  });

  var resizeFrame = 0;
  window.addEventListener('resize', function () {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(function () {
      document.querySelectorAll(ITEM + '.is-open').forEach(function (item) {
        var panel = panelFor(item);
        if (panel) panel.style.setProperty('max-height', panel.scrollHeight + 'px', 'important');
      });
    });
  }, { passive: true });

  function init() {
    enhance(document);
    if (!window.MutationObserver) return;
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            if (node.matches && node.matches(ITEM)) enhanceItem(node);
            enhance(node);
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
